(() => {
  const SELECTOR = '[data-cart-upsell-add]';

  async function addVariantToCart(variantId, triggerButton) {
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id).join(','));
      formData.append('sections_url', window.location.pathname);
    }

    const config = {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    };

    const response = await fetch(`${window.routes.cart_add_url}`, config);
    const data = await response.json();

    if (data.status) {
      // Error case. Surface via cartError pubsub for consistency.
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'cart-upsell',
          productVariantId: variantId,
          errors: data.errors || data.description,
          message: data.message,
        });
      }
      throw new Error(data.description || data.message || 'Cart add failed');
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-upsell',
        productVariantId: variantId,
        cartData: data,
      });
    }

    if (cart && typeof cart.renderContents === 'function') {
      if (triggerButton) cart.setActiveElement(triggerButton);
      cart.renderContents(data);
    }

    return data;
  }

  function onClick(event) {
    const button = event.target.closest(SELECTOR);
    if (!button) return;

    event.preventDefault();
    if (button.hasAttribute('aria-disabled') || button.disabled) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    const spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    addVariantToCart(variantId, button)
      .catch((err) => {
        console.error('cart-upsell', err);
      })
      .finally(() => {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
      });
  }

  document.addEventListener('click', onClick);
})();
